import React, { useCallback, useEffect, useState } from 'react';

import './expand.scss';
import classNames from 'classnames';

export const Expand = ({ label, isExpanded = false, children }) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);

  useEffect(() => {
    setIsExpandedLocal(isExpanded);
  }, [isExpanded]);

  const onClickExpand = useCallback(() => {
    setIsExpandedLocal((prev) => !prev);
  }, []);

  const labelStyles = classNames('expand__label', {
    'expand__label--active': isExpandedLocal,
  });

  return (
    <div className="expand">
      <div className={labelStyles} onClick={onClickExpand}>
        {label}
      </div>
      {isExpandedLocal && <div className="expand__content"> {children}</div>}
    </div>
  );
};
